import { parseLocalDateTime } from '@utils/date.utils';
import { isNull } from '@utils/js.utils';
import { isAfter } from 'date-fns';
import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'registerStartDate' | 'registerEndDate'>;

export const validate: FormValidator<Params> = ({
  registerStartDate,
  registerEndDate,
}) => {
  if (isNull(registerEndDate) || isNull(registerStartDate)) {
    return { isValid: false, message: '' };
  }

  if (
    isAfter(
      parseLocalDateTime(registerStartDate),
      parseLocalDateTime(registerEndDate),
    )
  ) {
    return {
      isValid: false,
      message: '모집 시작일은 모집 종료일보다 이전이어야 합니다.',
    };
  }

  return { isValid: true };
};
